import { isEqual } from 'lodash';
import React from 'react';
import { PiTrashDuotone } from 'react-icons/pi';
import { Button } from 'rizzui';
import CustomSelect from '../../../../../components/forms/CustomSelect';
import CustomTextDelayInput from '../../../../../components/forms/CustomTextDelayInput';
import DateField from '../../../../../components/forms/DateField';
import useProducts from '../../../../../hooks/api-calls/useProducts';
import useUsers from '../../../../../hooks/api-calls/useUsers';
import { STOCK_MOVEMENT_TYPE } from '../../../../../utils/mapping';

interface ProductStockMovementsFiltersProps {
    updateFilters: (filters: any) => void;
    filters: any;
}

const ProductStockMovementsFilters: React.FC<ProductStockMovementsFiltersProps> = ({ filters, updateFilters }) => {

    // HOOKS

    const { getUsersList } = useUsers();

    // RENDER 

    return (
        <>
            <CustomSelect
                required
                isSearchable
                isClearable
                id={'created_by'}
                label="Creado por"
                value={{ value: filters.filter_filters?.created_by, label: getUsersList()?.find((g: any) => g.value === filters.filter_filters?.created_by)?.label }}
                options={getUsersList()}
                onChange={
                    (e: any) => {
                        updateFilters({ created_by: e?.value });
                    }
                }
            />

            <CustomSelect
                required
                isSearchable
                id={'type'}
                label="Tipo de movimiento"
                value={{ value: filters.filter_filters?.type, label: STOCK_MOVEMENT_TYPE?.find((g: any) => g.value === filters.filter_filters?.type)?.label }}
                options={STOCK_MOVEMENT_TYPE}
                onChange={
                    (e: any) => {
                        updateFilters({ type: e?.value });
                    }
                }
            />

            <DateField
                isClearable
                className="w-full"
                label="Fecha de Creación"
                placeholderText="Selecciona las fechas"
                selectedDateField={filters.filter_filters?.between_dates?.type || "createdAt"}
                dateTypesOptions={[
                    { label: "Fecha de creación", value: "createdAt" },
                    { label: "Fecha de modificación", value: "updatedAt" }
                ]}
                startDate={filters.filter_filters?.between_dates?.startDate ? new Date(filters.filter_filters.between_dates.startDate) : null}
                endDate={filters.filter_filters?.between_dates?.endDate ? new Date(filters.filter_filters.between_dates.endDate) : null}
                onChange={(date: any) => {
                    const filters_between_dates = filters.filter_filters?.between_dates;
                    const between_dates = date ? { startDate: date[0], endDate: date[1] } : null;

                    if (between_dates && !isEqual(filters_between_dates, between_dates)) {
                        updateFilters({ between_dates: { startDate: date[0], endDate: date[1], type: date[2] } });
                    } else if (!between_dates && filters_between_dates) {
                        updateFilters({ between_dates: null });
                    }
                }}
            />

            <CustomTextDelayInput
                id={'source'}
                label="Origen/Destino"
                placeholder="Buscar por origen/destino"
                filters={filters}
                updateFilters={updateFilters}
            />

        </>
    );
};

export default ProductStockMovementsFilters;
